// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"4945187e","224":"6747ab6d","283":"05eb056f","618":"a7213454","686":"09f3f46a"}[chunkId] + ".chunk.js";
};